/* eslint-disable max-len */
import { Component, Inject, OnDestroy, OnInit, QueryList, ViewChildren } from '@angular/core';
import { MatDialog, MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';
import { MatSelectChange } from '@angular/material/select';
import { MatTable } from '@angular/material/table';
import { MatTabChangeEvent } from '@angular/material/tabs';
import { TranslateService } from '@ngx-translate/core';
import { saveAs } from 'file-saver';
import * as _ from 'lodash-es';
import { DateTime } from 'luxon';

import { Subject } from 'rxjs';
import { takeUntil } from 'rxjs/operators';
import { ExternalCalibration, ExternalCalibrationValue } from 'src/app/model/calibration';
import { VariableUnit } from 'src/app/model/variable';
import { AttachmentCalibratesService } from 'src/app/services/attachmentCalibrates.service';
import { ExternalCalibrationService } from 'src/app/services/externalCalibration.service';
import { SnackBarService } from 'src/app/services/snackBar.service';
import { SpinnerService } from 'src/app/services/spinner.service';
import { ThemeService } from 'src/app/services/theme.service';
import { VariableTypeService } from 'src/app/services/variableType.service';
import { CustomDatepickerHeaderComponent } from '../../shared/datepicker-custom-header/datepicker-custom-header.component';
import { InternalEquipmentEditCreateCalibrationValueComponent } from './internal-equipment-edit-create-calibration-value.component';
import { GenericClassTranslate } from '../../../model/genericClass';
import { ActionTypeService } from 'src/app/services/actionType.service';
import { EquipmentPerformances } from '../../../utils/equipmentUtils';
import { InternalEquipment } from '../../../model/internalEquipment';
import { InternalEquipmentPerformances } from '../../../model/internalEquipmentPerformances';
import { ExcelUtils } from '../../../utils/excelUtils';
import { VariableTypeEnum, Variable } from '../../../model/variable';
import { ArrayUtils } from '../../../utils/arrayUtils';
import { DateUtils } from '../../../utils/dateUtils';
import { NumberUtils } from '../../../utils/numberUtils';
import { ViewPdfService } from '../../../services/view-pdf.service';
import { FixDate } from '../../../pipes/fixDate.pipe';
import { ExternalCalibrationVariable } from '../../../model/calibration';

export interface DialogDataExternalCalibration {
  item: ExternalCalibration;
  idEquipment: number;
  nameEquipment: string;
  idsActions: number[];
  equipmentCalibration: InternalEquipmentPerformances;
  equipmentVerification: InternalEquipmentPerformances;
  frequency: any;
  isBalance: boolean;
  isParticles:boolean;
  idsVariables: number[];
  variables: Variable[];
}

@Component({
  selector: 'app-internal-equipment-edit-create-calibration',
  templateUrl: './internal-equipment-edit-create-calibration.component.html',
  standalone: false,
})
export class InternalEquipmentEditCreateCalibrationComponent implements OnInit, OnDestroy {

  @ViewChildren('valuesTable') asFoundTables: MatTable<any> | QueryList<MatTable<any>>;

  valuesCols = ['number', 'point', 'average', 'correction', 'U', 'edit', 'delete'];

  valuesBalanceCols = ['number', 'point', 'idMass', 'average', 'correction', 'U', 'edit', 'delete'];

  valuesParticlesCols = ['number','particlesSize', 'point', 'average', 'correction', 'U', 'edit', 'delete'];

  customDatepickerHeader = CustomDatepickerHeaderComponent;

  uploadFile: File = null;

  variableUnits: VariableUnit[];

  isEdit: boolean;

  actionTypes: GenericClassTranslate[] = [];

  idAction: number;
  maxDateCalibration = new Date();

  private destroy$ = new Subject<void>();

  constructor(
    @Inject(MAT_DIALOG_DATA) public data: DialogDataExternalCalibration,
    public dialogRef: MatDialogRef<InternalEquipmentEditCreateCalibrationComponent>,
    private viewPdfService: ViewPdfService,
    private attachmentCalibratesService: AttachmentCalibratesService,
    private variableTypeService: VariableTypeService,
    private translate: TranslateService,
    private themeService: ThemeService,
    public dialog: MatDialog,
    public snackBarService: SnackBarService,
    private spinnerService: SpinnerService,
    private fixDate: FixDate,
    private actionTypeService: ActionTypeService) {
    this.isEdit = this.data.item.id != null;
  }

  ngOnInit(): void {      
    this.actionTypeService.findAll().pipe(takeUntil(this.destroy$)).subscribe((data: GenericClassTranslate[]) => {
      for (let index = 0; index < this.data.idsActions?.length; index++) {
        const element = data.find(e => e.id === this.data.idsActions[index]);
        if (element) {
          this.actionTypes.push(element);
        }
      }
    });

    if (this.data.item.calibrationDate) {
      this.data.item.calibrationDate = DateUtils.normalizeDateTime(this.data.item.calibrationDate);
    }

    if (this.data.item.expirationDate) {
      this.data.item.expirationDate = DateUtils.normalizeDateTime(this.data.item.expirationDate);
    }

    if (ArrayUtils.isNotEmpty(this.data.item.variables)) {
      this.onVariableTabChange(0);
    }
  }

  ngOnDestroy(): void {
    this.destroy$.next();
    this.destroy$.complete();
  }

  saveDate(field: string, event: any): void {

    let value: Date = event.value;

    if (value != null) {

      let date = DateTime.utc(
        value.getFullYear(),
        value.getMonth() + 1,
        value.getDate(),
        12, 0, 0
      );

      while (date.year < 1970) {
        date = date.plus({ years: 100 });
      }

      if (field === 'calibrationDate') {
        this.data.item.calibrationDate = date.toJSDate();

        let frequency: number;

        this.data.item.expirationDate = _.cloneDeep(this.data.item.calibrationDate);

        if (this.data.item.actionType === EquipmentPerformances.CALIBRATION) {
          if (typeof this.data?.equipmentCalibration?.frequency === 'number'){
            frequency = Number(this.data.equipmentCalibration.frequency);
          } else {
             if (this.data?.equipmentCalibration?.frequency &&
              this.data.equipmentCalibration.frequency.match('^[0-9]+$')) {

              frequency = Number(this.data.equipmentCalibration.frequency);
            } else {
              frequency = 12;
            }
          }
        } else if (this.data.item.actionType === EquipmentPerformances.VERIFICATION) {
          if (typeof this.data?.equipmentVerification?.frequency === 'number'){
            frequency = Number(this.data.equipmentVerification.frequency);
          } else {
            if (this.data?.equipmentVerification?.frequency &&
              this.data.equipmentVerification.frequency.match('^[0-9]+$')) {

              frequency = Number(this.data.equipmentVerification.frequency);

            } else {
              frequency = 12;
            }
          }
          
        } else {
          frequency = 12;
        }

        this.data.item.expirationDate = _.cloneDeep(this.data.item.calibrationDate);
        this.data.item.expirationDate.setMonth(this.data.item.expirationDate.getMonth() + Number(frequency));

      } else {
        this.data.item[field] = date.toJSDate();
      }

    } else {
      this.data.item[field] = null;
    }
  }

  onVariableTabChange(event: MatTabChangeEvent | number): void {

    let index: number;

    if (event instanceof MatTabChangeEvent) {
      index = event.index;
    } else {
      index = event;
    }

    const tab = this.data.item.variables[index];

    this.variableUnits = [];

    if (tab != null && tab.idVariable != null) {
      this.variableTypeService.findUnits(tab.idVariable).pipe(takeUntil(this.destroy$)).subscribe((res: VariableUnit[]) => {
        this.variableUnits = res;

        // Solo al crear: al editar un registro existente no se reasigna la unidad automaticamente,
        // porque ese cambio se persistiria y el audit trail lo atribuiria al usuario (ALCOA+).
        if (!this.isEdit && (tab.idUnit == null || !this.variableUnits.map(v => v.id).includes(tab.idUnit))) {
          this.onUnitChange(index, res[0]);
        }
      });
    }

  }

  onUnitChange(indexVariable: number, event: MatSelectChange | VariableUnit): void {

    const variable = this.data.item.variables[indexVariable];

    let unit: VariableUnit;

    if (event instanceof MatSelectChange) {
      unit = this.variableUnits.find(v => v.id === event.value);
    } else {
      unit = event;
    }

    if (variable != null && unit != null) {
      variable.idUnit = unit.id;
      variable.unitName = unit.unit;

      this.data.item.variables[indexVariable] = variable;
    }
  }

  newValueRow(indexVariable: number): void {
    const variable = this.data.item.variables[indexVariable];

    const dialogRef = this.dialog.open(InternalEquipmentEditCreateCalibrationValueComponent, {
      minWidth: '50%',
      maxHeight: '95vh',
      data: {
        item: new ExternalCalibrationValue(),
        isBalance: this.data.isBalance,
        isParticles: this.data.isParticles
      }
    });

    dialogRef.afterClosed().pipe(takeUntil(this.destroy$)).subscribe((result: ExternalCalibrationValue) => {

      if (result != null) {
        variable.values.push(result);

        this.updateTable(this.asFoundTables);
      }
    });
  }

  editValueRow(indexVariable: number, index: number): void {
    const variable = this.data.item.variables[indexVariable];

    const row = variable.values[index];

    const dialogRef = this.dialog.open(InternalEquipmentEditCreateCalibrationValueComponent, {
      minWidth: '50%',
      maxHeight: '95vh',
      data: {
        item: _.cloneDeep(row),
        isBalance: this.data.isBalance,
        isParticles: this.data.isParticles
      }
    });

    dialogRef.afterClosed().pipe(takeUntil(this.destroy$)).subscribe((result: ExternalCalibrationValue) => {

      if (result != null) {
        variable.values[index] = result;

        this.updateTable(this.asFoundTables);
      }
    });
  }

  uploadMassiveBalanceMass(indexVariable: number, event): void {
    const variable = this.data.item.variables[indexVariable];

    this.spinnerService.show();

    const file = event.target.files[0] as File;

    void ExcelUtils.excelToBalanceMass(file).then(data => {
      variable.values = data;
      this.spinnerService.hide();
    }, error => {
      console.log(error);
      this.spinnerService.hide();
    });
  }

  downloadBalanceMass(): void {
    this.spinnerService.show();

    this.attachmentCalibratesService.downloadTemplateMass().pipe(takeUntil(this.destroy$))
      .subscribe((res: Blob) => {
        saveAs(res, this.data.nameEquipment + '.xlsx');
        this.spinnerService.hide();
      }, error => {
        console.error(error);
        this.spinnerService.hide();
      });

  }

  showUploadMass(): boolean {
    const resMass = this.data.item.variables.find(ev => ev.idVariable === VariableTypeEnum.MASS);
    if (resMass != null) {
      if (ArrayUtils.isEmpty(resMass.values)) {
        return true;
      } else {
        return false;
      }
    }
    return false;
  }


  uploadCertificateToEquipment(event): void {
    const file = event.target.files[0] as File;

    if (file == null) {
      return;
    }

    this.data.item.uploadFile = file;
  }

  downloadCertificateEquipment(): void {
    this.spinnerService.show();

    this.attachmentCalibratesService.downloadCertificateExternalCalibration(this.data.item.id).pipe(takeUntil(this.destroy$))
      .subscribe((res: Blob) => {
        //saveAs(res, this.data.nameEquipment + '.pdf');
        this.viewPdfService.setPdfBytes(res, this.data.item.certificateNum + '.pdf')
        this.spinnerService.hide();
      }, error => {
        console.error(error);
        this.spinnerService.hide();
      });

  }

  deleteValueRow(indexVariable: number, index: number): void {
    const variable = this.data.item.variables[indexVariable];
    variable.values.splice(index, 1);
    this.updateTable(this.asFoundTables);
  }

  onOkClick(): void {
    const errs = [];
    if (this.data.item.actionType == null) {
      errs.push(this.translate.instant('calibrateEquipmentEdit.general.actionType.error'));
    }
    if (this.data.item.certificateNum == null) {
      errs.push(this.translate.instant('calibrateEquipmentEdit.general.certificateNum.error'));
    }
    if (this.data.item.calibrationDate == null) {
      errs.push(this.translate.instant('calibrateEquipmentEdit.general.calibrateDate.error'));
    }
    if (this.data.item.expirationDate == null) {
      errs.push(this.translate.instant('calibrateEquipmentEdit.general.expirationDate.error'));
    }
    if (!this.data.item.uploadFile && !this.data.item.idDocument) {
      errs.push(this.translate.instant('calibrateEquipmentEdit.general.document.error'));
    }
    if (this.data.item.actionType === EquipmentPerformances.VERIFICATION || this.data.item.actionType === EquipmentPerformances.CALIBRATION) {
      if (this.data.item.variables.some(vari => vari.idUnit == null)) {
        errs.push(this.translate.instant('calibrateEquipmentEdit.calibrationData.unit.error'));
      }
    }

    this.data.item.calibrationDate = DateUtils.normalizeDateTime(this.data.item.calibrationDate);
    this.data.item.expirationDate = DateUtils.normalizeDateTime(this.data.item.expirationDate);

    this.data.item.idEquipment = this.data.idEquipment;
    if (errs.length === 0) {
      this.dialogRef.close(this.data.item);
    } else {
      const error = errs.join('\n');
      this.snackBarService.sendError(error);
      this.spinnerService.hide();
    }
  }

  onNoClick(): void {
    this.dialogRef.close();
  }

  getTheme(): string {
    return this.themeService.getTheme();
  }

  onChangeActionType(): void {
    if (!this.data.item.calibrationDate) {
      this.data.item.calibrationDate = new Date();
    }

    if (this.data.item.actionType === EquipmentPerformances.CALIBRATION || this.data.item.actionType === EquipmentPerformances.VERIFICATION) {
      if (this.data.idsVariables && !this.data.item.id) {
        for (let index = 0; index < this.data.idsVariables.length; index++) {
          const idVar = this.data.idsVariables[index];
          
          const variable = new ExternalCalibrationVariable();
          variable.idVariable = idVar;

          const vari = this.data.variables.find(v => v.id === idVar);
          variable.variableTranslation = vari.translation;

          this.data.item.variables.push(variable);
        }
      }
    }

    if (this.data.item.actionType === EquipmentPerformances.CALIBRATION) {
      this.onVariableTabChange(0);
      if (this.data.equipmentCalibration?.frequency) {
        if (typeof this.data.equipmentCalibration.frequency === 'string') {
          if (this.data.equipmentCalibration.frequency && this.data.equipmentCalibration.frequency?.match('^[0-9]+$')) {
            this.data.item.expirationDate = _.cloneDeep(this.data.item.calibrationDate);
            this.data.item.expirationDate.setMonth(this.data.item.expirationDate.getMonth() + Number(this.data.equipmentCalibration.frequency));
          } else {
            this.data.item.expirationDate = _.cloneDeep(this.data.item.calibrationDate);
            this.data.item.expirationDate.setFullYear(this.data.item.expirationDate.getFullYear() + 1);
          }
        } else {
          this.data.item.expirationDate = _.cloneDeep(this.data.item.calibrationDate);
          this.data.item.expirationDate.setMonth(this.data.item.expirationDate.getMonth() + Number(this.data.equipmentCalibration.frequency));
        }
      } else {
        this.data.item.expirationDate = _.cloneDeep(this.data.item.calibrationDate);
        this.data.item.expirationDate.setFullYear(this.data.item.expirationDate.getFullYear() + 1);
      }
    } else if (this.data.item.actionType === EquipmentPerformances.VERIFICATION) {
      this.onVariableTabChange(0);
      if (this.data.equipmentVerification.frequency) {
        if (typeof this.data.equipmentVerification.frequency === 'string') {
          if (this.data.equipmentVerification.frequency && this.data.equipmentVerification.frequency?.match('^[0-9]+$')) {
            this.data.item.expirationDate = _.cloneDeep(this.data.item.calibrationDate);
            this.data.item.expirationDate.setMonth(this.data.item.expirationDate.getMonth() + Number(this.data.equipmentVerification.frequency));
          } else {
            this.data.item.expirationDate = _.cloneDeep(this.data.item.calibrationDate);
            this.data.item.expirationDate.setFullYear(this.data.item.expirationDate.getFullYear() + 1);
          }
        } else {
          this.data.item.expirationDate = _.cloneDeep(this.data.item.calibrationDate);
          this.data.item.expirationDate.setMonth(this.data.item.expirationDate.getMonth() + Number(this.data.equipmentVerification.frequency));
        }
      } else {
        this.data.item.expirationDate = _.cloneDeep(this.data.item.calibrationDate);
        this.data.item.expirationDate.setFullYear(this.data.item.expirationDate.getFullYear() + 1);
      }
    } else {
      this.data.item.expirationDate = _.cloneDeep(this.data.item.calibrationDate);
      this.data.item.expirationDate.setFullYear(this.data.item.expirationDate.getFullYear() + 1);
    }
  }

  getDecimalsPattern(pattern: number): number {
    if (!pattern) {
      return 0;
    }
    return NumberUtils.countDecimals(pattern);
  }


  private updateTable(table: MatTable<any> | QueryList<MatTable<any>>) {
    if (table instanceof QueryList) {
      table.forEach(t => t.renderRows());
    } else {
      table.renderRows();
    }
  }

}
